/**
 * Status einer Kursbuchung
 */
export enum WorkshopBookingStatus {
   /**
    * Buchungsanfrage vom Kunden erhalten.
    */
   requested = "requested",

   /**
    * Kursbuchung ist auf Warteliste.
    */
   waitingList = "waitingList",

   /**
    * Buchung ist vollständig, Anzahlung kann vom Konto eingesammelt werden.
    */
   bookedReadyForDepositPayment = "bookedReadyForDepositPayment",

   /**
    * Buchung ist vollständig, Anzahlungsrechnung wurde exportiert.
    */
   bookedDepositPaymentExported = "bookedDepositPaymentExported",

   /**
    * Kurs durchgeführt, Rechnung kann gestellt werden.
    */
   readyForPayment = "readyForPayment",

   /**
    * Kurs wurde exportiert. Jetzt ist nichts mehr zu tun.
    */
   paymentExported = "paymentExported",

   /**
    * Kursbuchung wurde storniert. Rechnung fuer Stornierungsgebuehr kann gestellt werden.
    */
   canceled = "canceled",

   /**
    * Buchung wurde storniert und Stornierungsgebuehr wurde exportiert.
    */
   cancellationFeeExported = "cancellationFeeExported"
}